module.exports = __webpack_public_path__ + "img/changfang1.cb8f3c7e.png";